import React from 'react';
import * as PropTypes from 'prop-types';
import { Wrapper, TextWrapper, Title, Icon, TimeLabel } from './elements';
import Ico36 from 'dc/Ico36';

function APH120B(props) {
  return (
    <Wrapper className={props.className} onClick={props.onClick}>
      <Ico36 icon={props.leftIcon} />
      <TextWrapper>
        <Title>{props.title}</Title>
        <TimeLabel color={'#546e7a'} icon="icon-schedule">
          {props.time}
        </TimeLabel>
      </TextWrapper>
      <Icon icon={props.rightIcon} />
    </Wrapper>
  );
}

APH120B.propTypes = {
  className: PropTypes.string,
  leftIcon: PropTypes.string,
  rightIcon: PropTypes.string,
  title: PropTypes.node,
  onClick: PropTypes.func,
  time: PropTypes.node,
};
export default APH120B;
